<template>
    <div class="col-lg-9">
        <div class="d-flex align-items-center mb-2">
            <h4 class="text-7">Biller</h4>
            <router-link
                :to="`/business/payments/create`"
                class="btn btn-primary btn-sm text-white shadow-none ml-auto"
                v-if="stage === 7 && hasPermission(permissions, 'create-billers')"
            >
                <i class="fas fa-plus-circle mr-2"></i>Create Profile
            </router-link>
        </div>

        <div class="custom-nav-container mb-3">
            <ul class="custom-nav-tabs">
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link" :class="{ active: $route.path === '/business/payments' }" :to="`/business/payments`">
                        All Profiles
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link" :class="{ active: $route.path.includes('/profile') }" :to="`/business/payments/${$route.params.id}/profile`">
                        Profile
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link" :class="{ active: $route.path.includes('/view') }" :to="`/business/payments/${$route.params.id}/view`">
                        Payments
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link" :class="{ active: $route.path === '/business/wallets' }" :to="`/business/wallets`">
                        Balances
                    </router-link>
                </li>
            </ul>

            <div class="custom-nav-underline">
                <div class="custom-nav-active-underline" :style="{ left: activeTabPosition, width: activeTabWidth }"></div>
            </div>
        </div>

        <keep-alive>
            <transition name="slide-in-left">
                <router-view></router-view>
            </transition>
        </keep-alive>
    </div>
</template>

<script>
import Data from "../../../../core/data/Data";

export default {
    name: "Index",
    props: ["permissions"],
    data() {
        return {
            showToast: false,
            stage: 0,
            toastMessage: "",
            data: new Data({
                url: "/business/payments/list",
                prefix: "list"
            }),
            activeTabPosition: "0px",
            activeTabWidth: "0px"
        };
    },
    methods: {
        async setStage() {
            try {
                const response = await axios.get("/business/biller-onboarding/check-stage");
                const { body } = response.data;
                this.stage = body.status;
            } catch (error) {
                console.error("Error fetching biller status:", error);
                this.stage = 1;
            }
        },
        updateActiveTabPosition() {
            this.$nextTick(() => {
                const activeTab = document.querySelector(".custom-nav-tabs .custom-nav-link.active");
                if (activeTab) {
                    this.activeTabPosition = `${activeTab.offsetLeft}px`;
                    this.activeTabWidth = `${activeTab.offsetWidth}px`;
                }
            });
        }
    },
    mounted() {
        this.data.fetch();
        this.setStage();
        this.updateActiveTabPosition();
    },
    watch: {
        "$route.path": function () {
            this.updateActiveTabPosition();
        }
    }
};
</script>

